import audioScript from '../../src/audio.mp3';
import React from 'react';
import WorksGrid from './WorksGrid';
import { worksData, workTypes } from './data/worksData';

const AudioPlayer = props => {
  const audioRef = React.useRef(null);
 
  const play = () => audioRef.current.play();
  const pause = () => audioRef.current.pause();
  const setVolume = value => audioRef.current.volume = value;
 
  const divStyle = {
    color: '#fff'
  };

  return (
    <div style={{ display: 'flex', flexDirectoin: 'row', justifyContent: 'center' }}>
      <audio ref={audioRef} src={props.src} controls></audio>
    <small style={divStyle}>Если лень читать, можно послушать, никто не узнает 😉</small>
    </div>
  );
};

const About = () => {
  return (
    <div className="homepageBlock">
      <h3 className="about-header">Мои работы</h3>
      <main>
        <WorksGrid works={worksData} filters={workTypes} />
      </main>
    </div>
  );
};

export default About;